import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  logoVariants,
  bounce_right_to_left_variants
} from "shared/components/animations";

const VBJoining = ({ users }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="vb-lobby"
    >
      <motion.div
        variants={bounce_right_to_left_variants}
        className="vb-users-div"
      >
        <h2 className="heading">Waiting to Start</h2>
        <div className="vb-player-list">
          {users.map((user, index) => (
            <motion.div
              key={index}
              variants={logoVariants}
              className="player-div"
            >
              <div className="player-inner-div">
                <img alt="" src={user.profile_image} />
                <h2>{user.display_name}</h2>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default VBJoining;
